<script setup lang="ts">
import FileUpload from "~/components/Common/Upload/FileUpload.vue";
import { useNotificationsStore } from "~/store/notifications/notifications.store";
import { DocumentTypes } from "@simbelapp/order-sdk";

defineEmits(["hide", "reset"]);

const notificationStore = useNotificationsStore();
const { createSession } = storeToRefs(notificationStore);

const uploadModal: Ref<boolean> = ref(false);

function resetToggleShowMore() {
  //toggleShowMore.value = false;
  return false;
}

const defaultAttendees = computed(() => {
  return [
    {
      id: createSession?.value?.initDocument.itemId!,
      itemType: createSession?.value?.initDocument.itemType!,
      displayValue: createSession?.value?.initDocument.displayValue!,
    },
  ];
});
</script>
<template>
  <h1 class="heading_3_demi text-primary-color pb-6">Ajouter un document</h1>
  <FileUpload
    class="p-6"
    :default-attendees="defaultAttendees"
    :document-type="DocumentTypes.Other"
    :item-type="createSession?.initDocument.itemType!"
    :item-id="createSession?.initDocument.itemId!"
    :footer-upload="false"
    @hide="uploadModal = false"
    @resetToggleShowMore="resetToggleShowMore()"
  ></FileUpload>
</template>
<style scoped lang="scss">
.divider_header_footer {
  @apply flex border-b-[4px] border-light-grey-color justify-between rounded-[4px];
}
</style>
